import { ENV_VAR } from './enviroments'
import type { FetchOptions } from './interface'

export interface FetchResponse<T> {
  success: boolean
  data?: T
  error?: string
}

interface ExtendedFetchOptions extends FetchOptions {
  stringifyBody?: boolean
  // 🔹 Opciones de caché de Next.js
  revalidate?: number | false  // Segundos para revalidar, false = no cache
  tags?: string[]              // Tags para revalidación on-demand
  cacheStrategy?: 'force-cache' | 'no-store' | 'no-cache' | 'default'
}

export async function handleFetch<T = any>(
  endpoint: string, 
  options: ExtendedFetchOptions = {}
): Promise<FetchResponse<T>> {
  const { 
    method = 'GET', 
    headers = {}, 
    body, 
    next,
    stringifyBody = true,
    revalidate,
    tags,
    cacheStrategy
  } = options

  const baseUrl = ENV_VAR.API_URL
  const url = `${baseUrl}${endpoint}`
  console.log(`🔵 Fetching URL: ${url}`)
  // 🔹 Construir opciones de Next.js cache
  const nextOptions: NextFetchRequestConfig = {}
  
  if (revalidate !== undefined) {
    nextOptions.revalidate = revalidate
  }
  
  if (tags && tags.length > 0) {
    nextOptions.tags = tags
  }

  // 🔹 Determinar cache strategy
  let cache: RequestCache | undefined
  if (cacheStrategy) {
    cache = cacheStrategy
  }

  try {
    const fechaInicio: any = new Date()

    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      ...(body
        ? { body: stringifyBody ? JSON.stringify(body) : body }
        : {}),
      // 🔹 Next.js cache options
      ...(cache ? { cache } : {}),
      ...(Object.keys(nextOptions).length > 0 ? { next: { ...next, ...nextOptions } } : next ? { next } : {})
    })

    // console.log(`🟢 FETCHED DATA FROM: ${url}`)
    // console.log(body)

    const json = await response.json()
    // console.log(json)

    const fechaFin: any = new Date()
    const diferenciaMilisegundos = fechaFin - fechaInicio
    console.log('Duración:', endpoint, diferenciaMilisegundos)

    if (!response.ok) {
      const errorResponse = json
      return {
        success: false,
        error: errorResponse.message || `Error ${response.status}: ${response.statusText}`
      }
    }

    const data: T = json
    return { success: true, data }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Error desconocido al realizar la solicitud'
    }
  }
}
